import {Langdict} from './datamodel/langdict';
import {Registration} from './datamodel/registration';
import {CourseGroup} from './datamodel/course-group';
import {Course} from './datamodel/course';
import {ClassGroup} from './datamodel/class-group';
import {CourseUnit} from './datamodel/course-unit';
import {Injectable} from '@angular/core';
import {isUndefined} from 'util';

declare var $;

@Injectable({
  providedIn: 'root'
})
export class LeftMenuService {

  root: any;

  constructor() {
    this.root = $('nav:has(#submenu) .level1:has(.highlighted)');
  }

  updateMenu(tree) {
    $('.highlighted').removeClass('highlighted');
    if (tree.length === 0) {
      $('a', this.root).addClass('highlighted');
    }
    this._updateMenu(this.root, tree, 1);
  }

  addPath(items) {
    return this.updateMenu(this.genericMenu(items));
  }

  _updateMenu(root, tree, level) {
    root = $('ul', root);
    root.children().remove();

    if (tree.length === 0) {
      return;
    }

    tree.forEach(node => {
      const elem = $('<li>');
      elem.addClass('item');

      const link = $('<a>');
      link.attr('href', node.url);
      link.text(node.title ? node.title.toString() : '(brak)');

      elem.append(link);
      if (node.children && node.children.length > 0) {
        const subelem = $('<ul>');
        elem.append(subelem);
        this._updateMenu(elem, node.children, level + 1);
      } else {
        elem.addClass('highlighted');
      }
      root.append(elem);
    });
  }

  fold(nodes: Array<any>) {
    const result = {children: []};
    let obj = result;

    nodes.forEach(
      node => {
        obj.children = [node];
        obj = node;
      }
    );
    return result.children;
  }

  genericName(item) {
    try {
      return item.name();
    } catch (Exception) {
    }
    if (item.hasOwnProperty('name')) {
      return item.name;
    }
    if (item.hasOwnProperty('description')) {
      return item.description;
    }
  }

  genericNode(items) {
    const parts = items.map(i => i.getPathFragment()).reduce((a, b) => a.concat(b), []);
    return {
      title: this.genericName(items[items.length - 1]),
      url: '#/registrations/' + parts.map(x => encodeURIComponent(x)).join('/'),
      children: null
    };
  }

  genericMenu(items) {
    const prefixItems = [];
    const prefixNodes = [];
    items.forEach(
      item => {
        prefixItems.push(item);
        prefixNodes.push(this.genericNode(prefixItems));
      }
    );
    return this.fold(prefixNodes);
  }
}
